import { importProvidersFrom } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

import { ALL_ITEMS_INITIALIZER } from '@app/all-items/all-items.initializer';
import { INSPECTIONS_INITIALIZER } from '@app/inspections/inspections.initializer';
import { LOP_INITIALIZER } from '@app/lop/lop.initializer';
import { TemplatingPipe } from '@shared/pipes/templating.pipe';
import { NotificationEntitiesService } from '@notifications/services/notification-entities.service';
import { NotificationsService } from '@notifications/services/notifications.service';
import { ToastNotificationsService } from '@notifications/services/toast-notifications.service';
import { NOTIFICATIONS_STORE } from '@notifications/stores/notifications.store';

export const NOTIFICATIONS_PROVIDERS = [
  importProvidersFrom(
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      tapToDismiss: true,
      enableHtml: true
    })
  ),
  NotificationEntitiesService,
  NotificationsService,
  ToastNotificationsService,

  TemplatingPipe,

  NOTIFICATIONS_STORE,

  ALL_ITEMS_INITIALIZER,
  INSPECTIONS_INITIALIZER,
  LOP_INITIALIZER
];
